<script>
export default {
  name: "VIcon",
  props: {
    data: {
      type: String,
      default: null
    }
  }
};
</script>

<template>
  <span class="icon">
    <svg
      v-if="data === 'arrow-down'"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 200 200"
      fill="currentColor"
    >
      <path
        d="M127.17,117.17L104,140.34V50c0-2.21-1.79-4-4-4s-4,1.79-4,4v90.34l-23.17-23.17c-1.56-1.56-4.1-1.56-5.66,0
        c-1.56,1.56-1.56,4.09,0,5.66l30,30c0,0,0,0,0.01,0c0.18,0.18,0.39,0.35,0.6,0.49c0.1,0.07,0.21,0.11,0.32,0.17
        c0.12,0.07,0.24,0.14,0.37,0.19c0.13,0.06,0.27,0.09,0.41,0.13c0.11,0.03,0.22,0.08,0.34,0.1c0.26,0.05,0.52,0.08,0.78,0.08
        s0.52-0.03,0.78-0.08c0.12-0.02,0.22-0.07,0.34-0.1c0.14-0.04,0.28-0.07,0.41-0.13c0.13-0.05,0.25-0.13,0.37-0.2
        c0.11-0.06,0.22-0.1,0.32-0.17c0.22-0.15,0.42-0.31,0.6-0.49c0,0,0,0,0.01,0l30-30c1.56-1.56,1.56-4.09,0-5.66
        C131.27,115.61,128.73,115.61,127.17,117.17z"
      />
      <path
        d="M100,0C44.77,0,0,44.77,0,100c0,55.23,44.77,100,100,100s100-44.77,100-100C200,44.77,155.23,0,100,0z
        M100,192c-50.73,0-92-41.27-92-92S49.27,8,100,8s92,41.27,92,92S150.73,192,100,192z"
      />
    </svg>
    <svg
      v-else-if="data === 'arrow-left'"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 128 128"
      fill="currentColor"
    >
      <path
        d="M77.83,31.17c-1.56-1.56-4.1-1.56-5.66,0l-30,30c-1.56,1.56-1.56,4.09,0,5.66l30,30
        C72.95,97.61,73.98,98,75,98s2.05-0.39,2.83-1.17c1.56-1.56,1.56-4.09,0-5.66L50.66,64l27.17-27.17
        C79.39,35.27,79.39,32.73,77.83,31.17z"
      />
      <path
        d="M64,0C28.71,0,0,28.71,0,64s28.71,64,64,64s64-28.71,64-64S99.29,0,64,0z M64,120C33.12,120,8,94.88,8,64
        S33.12,8,64,8s56,25.12,56,56S94.88,120,64,120z"
      />
    </svg>
    <svg
      v-else-if="data === 'frame-gallery'"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1651.51 1403.97"
    >
      <linearGradient
        id="SVGID_4_"
        gradientUnits="userSpaceOnUse"
        x1="592.92"
        y1="558.9771"
        x2="1651.5131"
        y2="558.9771"
      >
        <stop offset="0.1" style="stop-color:#F5A800" />
        <stop offset="0.9" style="stop-color:#185A7D" />
      </linearGradient>
      <path
        fill="url(#SVGID_4_)"
        d="M751.74,18.76c7.23-3.08,14.72-5.82,22.49-8.19c162.72-49.8,241.21,86.03,307.49,205.76
        c58.89,106.37,137.55,210.6,246.15,266.34c176.65,90.66,385.27,209.52,306.52,448.74c-85.98,261.17-365.22,215.01-529.24,63.24
        c-94.68-87.61-182.82-181.91-268.34-278.4c-71.64-80.82-170.96-167.81-214.91-266.51C558.89,308.24,597.07,84.61,751.74,18.76z"
      />
    </svg>
    <svg
      v-else-if="data === 'frame-video'"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 723.24 894.44"
    >
      <linearGradient
        id="SVGID_1_"
        gradientUnits="userSpaceOnUse"
        x1="361.6207"
        y1="167.2441"
        x2="637.2313"
        y2="167.2441"
      >
        <stop offset="0" style="stop-color:#F17386" />
        <stop offset="1" style="stop-color:#00567A" />
      </linearGradient>
      <linearGradient
        id="SVGID_2_"
        gradientUnits="userSpaceOnUse"
        x1="0"
        y1="512.5442"
        x2="723.2413"
        y2="512.5442"
      >
        <stop offset="0" style="stop-color:#F17386" />
        <stop offset="1" style="stop-color:#00567A" />
      </linearGradient>
      <path
        fill="url(#SVGID_1_)"
        d="M404.84,96.5c35.96-48.63,91.77-84.17,157.4-95.69c30.3-5.32,61.21,16.31,71.67,43.27
        c13.99,36.06-19.38,62.71-41.33,87.63c-43.08,48.93-68.46,110.47-99.79,166.36c-13.3,23.72-34.93,39.99-66.03,35.74
        c-30.41-4.16-50.78-26.11-57.89-53.13C351.14,213.28,367.01,147.65,404.84,96.5z"
      />
      <path
        fill="url(#SVGID_2_)"
        d="M108.51,143.46c4.94-2.1,10.06-3.97,15.36-5.6c111.17-34.02,164.8,58.78,210.08,140.58
        c40.23,72.68,93.98,143.89,168.17,181.96C622.82,522.35,765.35,603.56,711.54,767c-58.74,178.43-249.52,146.9-361.58,43.21
        C285.28,750.35,225.06,685.92,166.63,620C117.68,564.78,49.83,505.35,19.8,437.92C-23.25,341.24,2.84,188.45,108.51,143.46z"
      />
    </svg>
    <svg
      v-else-if="data === 'frame-video-inverted'"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1248.26 790.55"
    >
      <linearGradient
        id="SVGID_5_"
        gradientUnits="userSpaceOnUse"
        x1="0"
        y1="175.6497"
        x2="356.8678"
        y2="175.6497"
      >
        <stop offset="0.1" style="stop-color:#00ADEE" />
        <stop offset="0.9" style="stop-color:#00567A" />
      </linearGradient>
      <linearGradient
        id="SVGID_6_"
        gradientUnits="userSpaceOnUse"
        x1="279.1761"
        y1="440.7566"
        x2="1248.2631"
        y2="440.7566"
      >
        <stop offset="0.1" style="stop-color:#00ADEE" />
        <stop offset="0.9" style="stop-color:#00567A" />
      </linearGradient>
      <path
        fill="url(#SVGID_5_)"
        d="M78.03,78.42C29.67,129.07,0.16,199.77,0,276.93c-0.08,35.62,30.71,66.6,63.54,73.21
      c43.91,8.83,67.7-34.52,91.8-64.49c47.3-58.82,112.49-99.95,170.05-146.77c24.43-19.86,38.71-47.76,27.71-82.4
      c-10.76-33.88-39.84-52.77-72.07-55.53C200.63-5.94,128.9,25.15,78.03,78.42z"
      />
      <path
        fill="url(#SVGID_6_)"
        d="M977.77,785.04c-40.91,6.74-85.31,7.24-132.46,1.81c-145.07-16.69-366.87-41.23-490.1-130.19
      c-113.8-82.16-90.39-242.49,7.8-326.61C533.59,183.9,806.4,53.06,1034.15,101.06c178.71,37.67,237.87,240.49,205.81,406.73
      C1207.85,674.27,1111.54,763.01,977.77,785.04z"
      />
    </svg>
    <svg
      v-else-if="data === 'horse'"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1285 1612.57"
      fill="currentColor"
    >
      <path
        d="M1238.94,1451.91c-47.45,27.44-116.17,48.13-206.09,61.97c-89.98,13.89-173.92,14.04-251.81,0.5
        c-156.55-27.9-284.47-94.33-383.7-199.29c-99.24-104.96-154.74-240.14-166.48-405.53c-6.82-90.93,1.24-175.44,24.07-253.54
        c22.87-78.05,55.56-143.04,98.15-194.98c42.59-51.89,91.93-93.2,147.96-123.94c56.09-30.74,115.15-48.22,177.18-52.41
        c5.97-0.36,11.48-0.67,16.67-0.92c10.68,1.25,19.96,2.77,27.01,4.34c60.33,13.46,88.6,77.48,88.6,77.48
        c44.62,110.51,185.33,126.4,230.48,159.74c33.9,25.03,23.45,55.75,23.45,55.75l19.58,32.1c41.31,15.55,101.71,28.75,101.71,28.75
        c13.24,0.14,61.13-46.64,61.13-46.64c7.02-36.28,10.33-80.36,10.33-80.36c-52.01-105.38-181.96-260.77-201.7-280.18
        C942.59,123.72,975.85,38.83,962.23,50.05c-56.93,46.9-27.45,112.75-32.55,108.82c-45.2-34.83-29.64-76.39-33.43-78.92
        C766.03-7.15,586.13-0.36,555.08,0.43c-108.05,2.76-152.3,27.74-134.66,23.83c68.71-15.2,156.37,10.31,156.37,10.31
        c25.23,5.38,82.3,33.4,66.35,30.7c-242.09-40.91-353.86,63.65-353.86,63.65c-9.97,6.27-67.19,67.83-55.15,59.78
        c112.32-75.13,226.77-50.36,226.77-50.36C214.37,163.98,130.8,387.38,142.12,374.34c91.14-105,181.62-96.65,213.99-86.4
        c-9.93,5.23-19.79,10.64-29.53,16.35c-137.17,80.4-233,201.13-287.49,362.19C19.44,727.38,7.38,782.83,2.87,832.87
        c-9.09,100.9,3.4,195.79,37.43,284.67c34.07,88.93,83.45,164.77,148.18,227.52c64.73,62.8,137.88,115.39,219.41,157.71
        c81.58,42.33,167.82,72.09,258.74,89.19c119.52,22.99,233.52,26.74,341.93,11.3c108.41-15.43,200.58-42.16,276.44-80.07
        L1238.94,1451.91z"
      />
    </svg>
    <svg
      v-if="data === 'horses'"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1240.42 679.99"
      fill="currentColor"
    >
      <path
        d="M522.44,612.25c-20.01,11.57-48.99,20.3-86.91,26.13c-37.94,5.86-73.34,5.92-106.18,0.21
        c-66.01-11.77-119.96-39.78-161.8-84.04c-41.85-44.26-65.25-101.26-70.2-171.01c-2.87-38.34,0.52-73.98,10.15-106.91
        c9.65-32.91,23.43-60.32,41.39-82.22c17.96-21.88,38.76-39.3,62.39-52.26c23.65-12.96,48.55-20.34,74.71-22.1
        c2.52-0.15,4.84-0.28,7.03-0.39c4.5,0.53,8.42,1.17,11.39,1.83c25.44,5.68,37.36,32.67,37.36,32.67
        c18.81,46.6,78.15,53.3,97.19,67.36c14.3,10.56,9.89,23.51,9.89,23.51l8.26,13.54c17.42,6.56,42.89,12.12,42.89,12.12
        c5.58,0.06,25.78-19.67,25.78-19.67c2.96-15.3,4.35-33.89,4.35-33.89c-21.93-44.44-76.73-109.96-85.05-118.15
        c-47.6-46.82-33.57-82.62-39.32-77.89c-24.01,19.78-11.58,47.54-13.73,45.89c-19.06-14.69-12.5-32.21-14.09-33.28
        C323.02-3.02,247.16-0.15,234.07,0.18c-45.56,1.16-64.22,11.7-56.78,10.05c28.97-6.41,65.94,4.35,65.94,4.35
        c10.64,2.27,34.71,14.08,27.98,12.95C169.12,10.28,121.98,54.37,121.98,54.37c-4.21,2.64-28.33,28.6-23.26,25.21
        c47.37-31.68,95.62-21.24,95.62-21.24C90.4,69.15,55.16,163.35,59.93,157.85c38.43-44.28,76.59-40.76,90.24-36.43
        c-4.19,2.21-8.34,4.49-12.45,6.89c-57.84,33.9-98.25,84.81-121.23,152.73C8.2,306.72,3.11,330.11,1.21,351.21
        c-3.83,42.55,1.44,82.56,15.78,120.04c14.37,37.5,35.19,69.48,62.49,95.94c27.29,26.48,58.14,48.66,92.52,66.5
        c34.4,17.85,70.77,30.4,109.11,37.61c50.4,9.69,98.47,11.28,144.19,4.77c45.72-6.51,84.58-17.78,116.57-33.76L522.44,612.25z"
      />
      <path
        d="M717.98,612.25c20.01,11.57,48.99,20.3,86.91,26.13c37.94,5.86,73.34,5.92,106.18,0.21
        c66.01-11.77,119.96-39.78,161.8-84.04c41.85-44.26,65.25-101.26,70.2-171.01c2.87-38.34-0.52-73.98-10.15-106.91
        c-9.65-32.91-23.43-60.32-41.39-82.22c-17.96-21.88-38.76-39.3-62.39-52.26c-23.65-12.96-48.55-20.34-74.71-22.1
        c-2.52-0.15-4.84-0.28-7.03-0.39c-4.5,0.53-8.42,1.17-11.39,1.83c-25.44,5.68-37.36,32.67-37.36,32.67
        c-18.81,46.6-78.15,53.3-97.19,67.36c-14.3,10.56-9.89,23.51-9.89,23.51l-8.26,13.54c-17.42,6.56-42.89,12.12-42.89,12.12
        c-5.58,0.06-25.78-19.67-25.78-19.67c-2.96-15.3-4.35-33.89-4.35-33.89c21.93-44.44,76.73-109.96,85.05-118.15
        c47.6-46.82,33.57-82.62,39.32-77.89c24.01,19.78,11.58,47.54,13.73,45.89c19.06-14.69,12.5-32.21,14.09-33.28
        C917.4-3.02,993.26-0.15,1006.35,0.18c45.56,1.16,64.22,11.7,56.78,10.05c-28.97-6.41-65.94,4.35-65.94,4.35
        c-10.64,2.27-34.71,14.08-27.98,12.95c102.09-17.25,149.22,26.84,149.22,26.84c4.21,2.64,28.33,28.6,23.26,25.21
        c-47.37-31.68-95.62-21.24-95.62-21.24c103.95,10.81,139.19,105.01,134.42,99.51c-38.43-44.28-76.59-40.76-90.24-36.43
        c4.19,2.21,8.34,4.49,12.45,6.89c57.84,33.9,98.25,84.81,121.23,152.73c8.29,25.68,13.38,49.06,15.28,70.17
        c3.83,42.55-1.44,82.56-15.78,120.04c-14.37,37.5-35.19,69.48-62.49,95.94c-27.29,26.48-58.14,48.66-92.52,66.5
        c-34.4,17.85-70.77,30.4-109.11,37.61c-50.4,9.69-98.47,11.28-144.19,4.77c-45.72-6.51-84.58-17.78-116.57-33.76L717.98,612.25z"
      />
    </svg>
    <svg
      v-if="data === 'kid-jumping' || data === 'kid-jumping-inverted'"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1060.04 1855.83"
      fill="currentColor"
    >
      <path
        d="M1053.69,753.59c-18.98-14.61-58.18-16.99-77.4-7.06c-15.67,8.11-32.36,14.4-49.01,20.36
        c-4.49,1.61-11.14,0.47-15.66-1.73c-44.84-21.9-89.03-45.2-134.31-66.11c-19.85-9.17-41.47-15.29-62.9-20.02
        c-26.43-5.83-53.45-9.15-80.31-12.83c-20.36-2.79-37.61-11.15-54.43-22.95c-14.25-10-30.68-20.94-47.12-22.77
        c-21.29-2.38-32.13-11.81-39.27-29.68c-4.56-11.41-12.08-19.94-24.47-23.01c-4.83-1.19-10-1.16-14.7-2.67
        c-10.92-3.5-15.04-14.5-6.7-19.19c16.69-9.39,19.21-34.46,41.83-36.6c1.22-0.12,2.33-2.26,3.35-3.57
        c17.93-23.01,33.68-46.99,35.45-77.43c1-17.27,4.79-33.72,13.66-48.92c2.26-3.86,2.73-9.03,3.12-13.67
        c0.86-10.28,1.93-19.37-7.53-28.65c-7.12-6.99-7.38-20.54-12.33-30.33c-2.97-5.88-8.37-11.29-13.97-14.92
        c-10.42-6.76-21.78-12.05-32.73-17.98c-3.31-1.79-6.37-4.31-9.89-5.44c-11.99-3.84-25.07-5.42-35.98-11.19
        c-15-7.93-29.31-11.59-45.47-5.39c-3.07,1.18-6.42,2.64-9.56,2.48c-24.68-1.3-38.95,17.08-56.07,29.75
        c-3.93,2.91-4.77,11.93-8.43,12.9c-14.5,3.85-18.76,15.27-22.16,27.02c-2.61,9.02-2.41,18.81-4.49,28.02
        c-7.3,32.25-15.4,64.23-4.81,97.54c3.95,12.41,2.56,27.45,20.56,29.96c1.2,0.17,2.71,2.19,3.08,3.61
        c4.22,16.36,8.25,32.77,13.3,53.07c-7.31-3.87-11.33-4.82-13.52-7.35c-22.66-26.16-42.04-54.27-50.29-88.61
        c-5.44-22.62-8.94-45.91-16.6-67.75c-7.13-20.32-8.51-38.42,3.36-56.99c3.2-5.01,4.5-11.28,6.44-17.06
        c15.13-45.17,30-90.44,45.52-135.48c2.26-6.57,6.85-12.7,11.53-18.02c11.28-12.85,23.07-25.26,35.01-37.5
        c4.59-4.7,10.51-8.11,15.18-12.74c3.44-3.41,5.84-7.86,8.7-11.84c-5.34-2.2-10.97-6.67-15.96-6.06c-7.66,0.94-14.9,5.39-24.44,9.21
        c10.47-17.14,20.05-32.51,29.29-48.08c4.08-6.87,12.52-15.57,3.95-21.95c-9.7-7.23-13.3,5.56-18.56,10.92
        c-7.37,7.52-14.23,15.53-21.3,23.34c-1.19-0.88-2.38-1.76-3.57-2.64c1.78-8.55,3.87-17.06,5.25-25.68
        c1.21-7.54,7.96-18.34-3.76-21.19c-11.4-2.78-10.57,10.2-13.79,17.13c-4.37,9.42-8.23,19.07-12.3,28.63
        c-1.72-0.31-3.45-0.62-5.17-0.93c-1.86-5.59-4.07-11.09-5.5-16.78c-1.62-6.45-1.83-13.32-4.05-19.52c-1.28-3.58-5.31-6.18-8.1-9.22
        c-3.01,3.39-7.96,6.45-8.61,10.24c-1.28,7.52-0.41,15.46,0.03,23.2c0.32,5.65,1.36,11.26,2.08,16.89c-1.34,0.53-2.68,1.07-4.02,1.6
        c-3.79-5.05-7.98-9.85-11.25-15.21c-2.86-4.7-3.91-10.65-7.22-14.9c-2.57-3.31-7.4-4.85-11.23-7.18c-1.26,3.88-4.11,8.05-3.47,11.6
        c1.56,8.67,5.14,16.95,7.15,25.56c2.99,12.76,6.01,25.57,7.81,38.53c4.69,33.87-4.73,64.58-21.7,93.65
        c-6.98,11.96-13.52,24.34-18.66,37.17c-21.47,53.54-43.78,106.7-34.24,167.03c7.27,45.97,12.09,92.15,28.18,136.45
        c10.63,29.25,17.2,59.81,6.52,91.2c-2.67,7.84-4.81,16.12-5.44,24.34c-1.8,23.5-3.44,47.05-3.68,70.6
        c-0.17,16.38,2.72,32.76,3.1,49.17c0.92,39.27-1.77,78.9,2.77,117.71c2.79,23.89,4.32,46.69,0.51,70.23
        c-0.51,3.16,2.84,8.06,5.78,10.48c14.1,11.59,16.83,16.87,8.16,31.79c-10.93,18.8-15.35,38.37-16.74,59.86
        c-1.92,29.59-12.68,58.4-7.44,88.79c1.37,7.96,1.07,16.64-0.48,24.6c-3.71,19-10.97,37.57-12.5,56.66
        c-2.28,28.48-19.72,56.1-5.86,85.7c0.75,1.61-0.49,4.33-1.16,6.41c-9.27,28.44-16.67,57.69-28.41,85.07
        c-15.84,36.94-28.45,74.52-36.27,113.9c-9.8,49.43-20.55,98.67-30.39,148.09c-2.31,11.61-3.53,22.74-16.94,27.62
        c-2.79,1.01-4.28,6.17-5.94,9.63c-7.16,14.94-11.94,31.62-21.67,44.6c-20.27,27.05-25.05,57.55-24.31,89.45
        c0.15,6.45,7.12,15.64,13.3,18.57c38.29,18.1,93.73-1.64,105.4-41.84c6.61-22.77,17.04-39.06,33.27-54.09
        c4.34-4.01,8.33-9.66,9.77-15.25c2.13-8.24,4.21-17.75,2.08-25.56c-4.49-16.5-12.49-32.01-17.5-48.4
        c-2.61-8.55-3.86-18.42-2.43-27.15c7.04-42.95,28.76-80.01,48.38-118.01c10.08-19.52,17.05-40.64,25.62-60.96
        c5.34-12.65,9.19-26.45,16.94-37.46c19.08-27.11,36.14-54.51,38.61-88.77c0.75-10.48,5.71-18.1,17.08-22.08
        c47.53-16.65,111.02-1.94,104.34-139.63c5.94,2.4,42.45,96.81,81.54,88.23c38.77-5.35,47.75-20.96,68.18-25.4
        c20.75-4.51,31.9-8.72,46.22,10.77c15.66,21.31,38.7,32.24,63.3,40.85c11.23,3.93,23.01,9.73,31.3,17.96
        c19.46,19.31,43.07,30.67,67.29,42.03c27.59,12.94,54.3,27.77,81.43,41.69c9.65,4.95,15.15,12.45,16.27,23.41
        c1.86,18.17,4.95,36.26,5.88,54.47c0.73,14.13,6.18,24.01,19.79,27.07c12.82,2.88,26.22,3.1,39.21,5.39
        c7.15,1.26,14.12,3.98,20.9,6.73c5.96,2.42,11.24,6.75,17.32,8.58c39.79,12.01,71.08-6.6,101.14-28.94
        c7.63-5.67,6.38-11.99,0.46-18.36c-6.78-7.31-13.57-14.63-20-22.24c-8.97-10.63-19.31-17.32-34.04-17.84
        c-10.05-0.35-18.4-4.56-21.58-16.85c-3.66-14.12-22.24-22.68-37.28-21.2c-6.41,0.63-14.75-0.34-19.52-4.05
        c-34.97-27.23-69.91-54.47-99.48-87.98c-28.03-31.78-60.21-58.39-98.08-78.54c-30.49-16.22-57.09-37.7-75.53-68.35
        c-12.24-20.33-26.19-39.81-41.01-58.37c-18.33-22.94-38.91-44.08-57.32-66.97c-6.09-7.57-11.62-12.13-21.43-13.14
        c-4.76-0.49-12.1-4.84-12.98-8.67c-2.79-12.13-9.18-19.59-20.42-24.16c-3.92-1.59-9.17-4.67-10.1-8.08
        c-6.22-22.9-13.53-45.84-16.06-69.24c-1.2-11.08-0.55-21.44-7.12-31.14c-2.51-3.7-4.74-8.93-4.22-13.1
        c3.47-27.84,7.28-55.65,11.93-83.31c1.97-11.69,4.58-23.84,9.85-34.3c11.33-22.44,36.95-32.92,56.89-26.15
        c58.28,19.81,116.3,40.5,175.18,58.39c42.38,12.87,86.09,21.27,128.93,32.72c19.12,5.11,40.1,9.19,55.68,20.18
        c24.37,17.19,50.05,15.75,76.5,14.74c4.41-0.17,8.62-5.41,12.92-8.31c-3.26-4.61-5.62-10.64-10.03-13.47
        c-5.14-3.3-12.08-3.8-18.5-5.59c1.67-14.88,11.09-19.18,22.21-19.18c7.49,0,15.05,2.98,22.45,5.07c6.83,1.93,13.65,5.57,20.5-4.33
        c-6.74-7.05-13.53-14.14-22.2-23.2c7.99,0.37,13.64-0.92,17.63,1.09C1036.29,777.5,1045.79,769.1,1053.69,753.59z"
      />
    </svg>
  </span>
</template>
